//import './vendor.js';
import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import brands from '@fortawesome/fontawesome-free-brands';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all.js';
import 'lazysizes/lazysizes.min.js';
import 'isotope-layout/dist/isotope.pkgd.js';
import 'imagesloaded/imagesloaded.pkgd.js';
import 'select2/dist/js/select2.js';
import noUiSlider from 'nouislider';
import 'jquery-match-height/dist/jquery.matchHeight.js';
import 'flickity-bg-lazyload/bg-lazyload.js';
import wNumb from './wnumb-1.1.0/wNumb';

var range = document.getElementById('price-slider');


fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	function addParameterAndReturn(url, paramName, paramValue)
	{
	    if (url.indexOf(paramName + "=") >= 0)
	    {
	        var prefix = url.substring(0, url.indexOf(paramName));
	        var suffix = url.substring(url.indexOf(paramName));
	        suffix = suffix.substring(suffix.indexOf("=") + 1);
	        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
	        url = prefix + paramName + "=" + paramValue + suffix;
	    }
	    else
	    {
	    if (url.indexOf("?") < 0)
	        url += "?" + paramName + "=" + paramValue;
	    else
	        url += "&" + paramName + "=" + paramValue;
	    }
	    return url;
	}

	function myAddParameterAndReturn(url, paramName, paramValue)
	{
	    if (url.indexOf(paramName + "=") >= 0)
	    {
	        var prefix = url.substring(0, url.indexOf(paramName));
	        var suffix = url.substring(url.indexOf(paramName));
	        suffix = suffix.substring(suffix.indexOf("=") + 1);
	        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
	        url = prefix + paramName + "=" + paramValue + suffix;
	    }
	    else
	    {
	    if (url.indexOf("?") < 0)
	        url += "?" + paramName + "=" + paramValue;
	    else
	        url += "&" + paramName + "=" + paramValue;
	    }
	    return url;
	}

	function preventDefault(e) {
	  e = e || window.event;
	  if (e.preventDefault)
	      e.preventDefault();
	  e.returnValue = false;  
	}

	function keydown(e) {
	    for (var i = keys.length; i--;) {
	        if (e.keyCode === keys[i]) {
	            preventDefault(e);
	            return;
	        }
	    }
	}

	function wheel(e) {
	  preventDefault(e);
	}

	function disable_scroll() {
	  if (window.addEventListener) {
	      window.addEventListener('DOMMouseScroll', wheel, false);
	  }
	  window.onmousewheel = document.onmousewheel = wheel;
	  document.onkeydown = keydown;
	}

	function enable_scroll() {
	    if (window.removeEventListener) {
	        window.removeEventListener('DOMMouseScroll', wheel, false);
	    }
	    window.onmousewheel = document.onmousewheel = document.onkeydown = null;  
	}

	

	function isScrolledIntoView(elem) {
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(window).height();

	    var elemTop = $(elem).offset().top;
	    var elemBottom = elemTop + $(elem).height();

	    return ((elemTop <= (docViewTop + $(window).height())));
	}
	
	function revealElements() {
		$('.reveal, .reveal1, .reveal2, .reveal3, .reveal4, .revealLeft, .revealRight').each(function () {
		var $revealElement = $(this);
		if (isScrolledIntoView($revealElement) === true) {
	   		if ($revealElement.data('delay')) {
	        	setTimeout(function(){
	            	$($revealElement).addClass('revealed');
	       		}, $revealElement.data('delay'));
	        } else {
                setTimeout(function(){
                    $($revealElement).addClass('revealed');
                }, 0);
            }
	        }
	    });
	}

	function fadeRevealElements() {
		$('.fadeReveal, .fadeReveal1, .fadeReveal2, .fadeReveal3, .fadeReveal4').each(function () {
		var $revealElement = $(this);
		if (isScrolledIntoView($revealElement) === true) {
	   		if ($revealElement.data('delay')) {
	        	setTimeout(function(){
	            	$($revealElement).addClass('fadeRevealed');
	       		}, $revealElement.data('delay'));
	        } else {
                setTimeout(function(){
                    $($revealElement).addClass('fadeRevealed');
                }, 0);
            }
	        }
	    });
	}

	function countNumberAnimation() {
		$('.box-wrapper__box-text H1').each(function(){
			$(this).prop('Counter',0).animate({
				Counter: $(this).text()
			}, {
				duration: 7000,
				easing: 'swing',
				step: function (now) {
					$(this).text(Math.ceil(now));
				}
			});
		});
	}

	$('.nav .menu-item-has-children > a').on('click', function(e){
		e.preventDefault();
		return false;
	});

	$('.nav .menu-item-has-children').on('mouseenter', function(e){
		e.preventDefault();
		//console.log('mouseenter');
		//$('.nav .menu-item-has-children').find('.sub-menu').removeClass('sub-open');
		$(this).find('.sub-menu').addClass('sub-open');
	}).on('mouseleave', function(e){
		e.preventDefault();
		//console.log('mouseleave');
		$('.nav .menu-item-has-children').find('.sub-menu').removeClass('sub-open');
	});

	$('.casawp-carousel').lightGallery({
		selector: '.item .property-image-gallery',
		download: false,
		thumbnail: false
	});

	$('.blocks-gallery-item img').each(function(e){
		if (this.src.length > 0) {
	        var image = $(this).attr('src');
	        $(this).parent().attr('data-src', image);
	    }   
	});


	$('.single-news .content-wrapper__inner').lightGallery({
		selector: '.blocks-gallery-item figure',
		download: false,
		thumbnail: false
	});

	$('.link-to-bottom').on('click', function(){
		disable_scroll();
		$('html, body').stop().animate({
			scrollTop: $('.site-content').offset().top
		}, 700, function(){
			enable_scroll();
		});
		return false;
	});

	$('.match-height').matchHeight();

	$('.casawp-radio-label').append('<i class="fal fa-check"></i>');
	$('.filterOuter').append('<i class="fal fa-angle-down"></i>');
	$('.casawp-contactform-form select').after('<i class="fal fa-angle-down"></i>');
	//$('.wpforms-field-radio input').after('<i class="fal fa-check"></i>');


	document.addEventListener('lazybeforeunveil', function(e){
		var bg = e.target.getAttribute('data-bg');
		if(bg){
			e.target.style.backgroundImage = 'url(' + bg + ')';
		}
	});		

	lazySizes.autoSizer.checkElems();

	revealElements();
	fadeRevealElements();
	countNumberAnimation();	
	$(window).on('scroll', function(){
		revealElements();
		fadeRevealElements();
	});

	if($('.header-archive-filter').length){
		$( ".content-wrapper" ).first().addClass( "content-wrapper-top" );
	}

	/* Bewerten Stoerer */
	if ($('.bewerten-stoerer').length) {
		$('.bewerten-stoerer').addClass('nav-stoerer--active');
	}

	$('.bewerten-stoerer__close-btn').on('click', function(e){
		e.preventDefault();
		$('.bewerten-stoerer').css('transition-delay', '0s');
		if ($(this).parent().parent().hasClass('nav-stoerer--active')) {
			$('.bewerten-stoerer').removeClass('nav-stoerer--active');
			if (!$('.bewerten-stoerer-ribbon').hasClass('bewerten-stoerer-ribbon--active')) {
				$('.bewerten-stoerer-ribbon').addClass('bewerten-stoerer-ribbon--active');
			}
		}
		return false;
	});

	$('.bewerten-stoerer-ribbon__get-stoerer').on('click', function(e){
		e.preventDefault();
		if (!$(this).parent().find('.bewerten-stoerer').hasClass('nav-stoerer--active')) {
			$('.bewerten-stoerer').addClass('nav-stoerer--active');
			$('.nav-stoerer--active').css('transition-delay', '0');
			if ($('.bewerten-stoerer-ribbon').hasClass('bewerten-stoerer-ribbon--active')) {
				$('.bewerten-stoerer-ribbon').removeClass('bewerten-stoerer-ribbon--active');
			}
		}
		return false;
	});

	$(window).on('scroll', function(){
		var offset = $(window).scrollTop();
		if(window.matchMedia("(max-width: 990px)").matches){
			var headerHeight = $('#header').outerHeight() - 149;
		} else{
			var headerHeight = $('#header').outerHeight();
		}
		if (offset >= headerHeight && $('.bewerten-stoerer').hasClass('nav-stoerer--active')) {
			$('.bewerten-stoerer').removeClass('nav-stoerer--active');
			if (!$('.bewerten-stoerer-ribbon').hasClass('bewerten-stoerer-ribbon--active')) {
				$('.bewerten-stoerer-ribbon').addClass('bewerten-stoerer-ribbon--active');
			}
		} 
		else if(offset < headerHeight){
			$('.bewerten-stoerer').addClass('nav-stoerer--active');
			if ($('.bewerten-stoerer-ribbon').hasClass('bewerten-stoerer-ribbon--active')) {
				$('.bewerten-stoerer-ribbon').removeClass('bewerten-stoerer-ribbon--active');
			}
		}
	})

	$('.navbar-toggler').on('click', function(){
		if ($(this).hasClass('active-nav')) {
			$(this).removeClass('active-nav');
			$('.navbar-outer').removeClass('nav-bg');
		} else {
			$(this).addClass('active-nav');
			$('.navbar-outer').addClass('nav-bg');
			$('.banner-stoerer').fadeOut();
		}
	});

	$('.navbar-collapse').on('shown.bs.collapse', function(){
		$('#footer').hide();
		$('.site-content').hide();
		$('.slider-outer').hide();
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('show.bs.collapse', function(){
		$('.navbar-toggler').addClass('dontClick');
	});

	$('.navbar-collapse').on('hidden.bs.collapse', function(){
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('hide.bs.collapse', function(){
		$('#footer').show();
		$('.site-content').show();
		$('.slider-outer').show();
		$('.navbar-toggler').addClass('dontClick');
	});

	if ($('.newsGrid').length) {
		var $grid = $('.newsGrid').isotope({
			itemSelector: '.grid-item',
			layoutMode: 'fitRows',
			fitRows: {
				gutter: 0
			}
		});

		$grid.imagesLoaded().progress( function() {
			$grid.isotope({
				itemSelector: '.grid-item'
			});
		});
	}

	if ($('.filters-select').length) {
		$('.filters-select').select2({
			dropdownParent: $('.filterOuter')
		});	
		$('.filters-select').on( 'change', function() {
			var filterValue = this.value;
			$grid.isotope({ filter: filterValue });
		});
	}

	//Slider für den Banner Bereich auf jeder Seite
	if ($('.slider-outer__slider').length) {
		var slider = new Flickity('.slider-outer__slider', {
			cellAlign: 'left',
			fade: true,
			imagesLoaded: true,
			pageDots: false,
			prevNextButtons: false,
			draggable: false,
			autoPlay: 7000,
			bgLazyLoad: true,
			setGallerySize: false
		});
	}


	if ($('.content-wrapper__slider').length) {
		var flky = new Flickity( '.content-wrapper__slider', {
			cellAlign: 'left',
			contain: true,
			imagesLoaded: true,
			prevNextButtons: true,
			pageDots: false,
			draggable: false,
			arrowShape: 'M7.9948243,51 L25.6594402,67.871693 C26.0588254,68.2531507 26.0733584,68.8861488 25.6919008,69.285534 C25.3104431,69.6849191 24.6774449,69.6994522 24.2780598,69.3179945 L4.80930978,50.7231508 C4.39689674,50.32925 4.39689674,49.67075 4.80930978,49.2768492 L24.2780598,30.6820055 C24.6774449,30.3005478 25.3104431,30.3150809 25.6919008,30.714466 C26.0733584,31.1138512 26.0588254,31.7468493 25.6594402,32.128307 L7.9948243,49 L95,49 C95.5522847,49 96,49.4477153 96,50 C96,50.5522847 95.5522847,51 95,51 L7.9948243,51 Z'
		});
		window.addEventListener( 'load', function() {
			flky.resize();
		});
	}

	$('.panel-collapser').on('shown.bs.collapse', function(event){
		event.stopPropagation();
		return false;
	});


	function getURLParameter(name) {
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search)||[,""])[1].replace(/\+/g, '%20'))||null
	}

	/* Map & Markers */

	var geoMarkers = [];
	var googleMapMarkers = [];
	var markerCluster = [];

	function requestMarkers(map, url, oms){
		deleteMarkers();

		$.ajax({
			dataType: "json",
			url: url + "&posts_per_page=100",
		}).done(function(json) {
			$.each(json, function(index, elem){
			geoMarkers.push({
					"type": "Feature",
					"geometry": {
						"type": "Point",
						"coordinates": [
							elem.address.lng,
							elem.address.lat
						]
					},
					"properties": {
						"postid" : elem.post.ID,
						"link": elem.permalink,
						"marker": elem.markerIcon
					}
				});
			})
		oms.removeAllMarkers();
		setMarkers(map, geoMarkers, oms);

		}).always(function(){
			// console.log("request complete");
		})

	}

	function setMarkers(map, geoMarkers, oms){
		var geojson =
		{
			"type": "FeatureCollection",
			"features": geoMarkers
			
		};

		
		//console.log(geojson);
		if (geojson.features.length >= 1) {
			var bounds = new google.maps.LatLngBounds();	
			var prev_infowindow = false;         
			
			geojson.features.forEach(function(feature) {
				if (feature.geometry.coordinates[1] && feature.geometry.coordinates[0]) {
				var icon = new google.maps.MarkerImage(
							//feature.properties.marker,
							'/wp-content/themes/cs_premiumhomes/img/marker_immo.svg',
							new google.maps.Size(43,54),
							null,
							null,
							new google.maps.Size(43,54)
						);
				
				var markerpos = new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
				var marker = new google.maps.Marker({
					position: {
					lat: parseFloat(feature.geometry.coordinates[1]),
					lng: parseFloat(feature.geometry.coordinates[0])
					}
				});
				marker.setIcon(icon);
				oms.addMarker(marker);
				googleMapMarkers.push(marker);

					if($('.no-links')[0]){

					} else{
					google.maps.event.addListener(marker, 'spider_click', function() {
						window.open(feature.properties.link);
						});
					}

				bounds.extend(markerpos);
				}
			});

			var clusterStyles = [
				{
					url: '/wp-content/themes/cs_premiumhomes/img/marker_contact.svg',
					height: 54,
					width: 43,
					textSize: 16,
					textColor: 'white',
					backgroundPosition: 'top',
				}
			];

			var mcOptions = {
				gridSize: 50,
				styles: clusterStyles,
				maxZoom: 12
			};

			markerCluster = new MarkerClusterer(map, googleMapMarkers, mcOptions);




			google.maps.event.trigger(map, "resize");
			$('.loading-overlay').hide();
			if (geoMarkers.length > 1) {
				map.fitBounds(bounds);
				setTimeout(function(){
				map.setZoom(map.getZoom());
				}, 100)
				
			} else {
				map.fitBounds(bounds);
				map.setZoom(12);
			}
		};
	}

	function deleteMarkers() {
		for(var i=0; i<googleMapMarkers.length; i++){
			markerCluster.removeMarker(googleMapMarkers[i]);
		}
		googleMapMarkers = [];
		geoMarkers  = [];
	}

	/* Map & Filter */

	function initializeMapBoxCasaWP() {

		var style = [
			{
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#f5f5f5"
				}
			]
			},
			{
			"elementType": "labels.icon",
			"stylers": [
				{
				"visibility": "off"
				}
			]
			},
			{
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#616161"
				}
			]
			},
			{
			"elementType": "labels.text.stroke",
			"stylers": [
				{
				"color": "#f5f5f5"
				}
			]
			},
			{
			"featureType": "administrative.country",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#4dbbc3"
				}
			]
			},
			{
			"featureType": "administrative.land_parcel",
			"elementType": "labels.text",
			"stylers": [
				{
				"color": "#4dbbc3"
				}
			]
			},
			{
			"featureType": "administrative.land_parcel",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#4dbbc3"
				}
			]
			},
			{
			"featureType": "administrative.locality",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#4dbbc3"
				}
			]
			},
			{
			"featureType": "administrative.neighborhood",
			"stylers": [
				{
				"visibility": "off"
				}
			]
			},
			{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#eeeeee"
				}
			]
			},
			{
			"featureType": "poi",
			"elementType": "labels.text",
			"stylers": [
				{
				"visibility": "off"
				}
			]
			},
			{
			"featureType": "poi",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#757575"
				}
			]
			},
			{
			"featureType": "poi.park",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#e5e5e5"
				}
			]
			},
			{
			"featureType": "poi.park",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			},
			{
			"featureType": "road",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#ffffff"
				}
			]
			},
			{
			"featureType": "road",
			"elementType": "labels",
			"stylers": [
				{
				"visibility": "off"
				}
			]
			},
			{
			"featureType": "road.arterial",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#757575"
				}
			]
			},
			{
			"featureType": "road.highway",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#dadada"
				}
			]
			},
			{
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [
				{
				"color": "#c3eeea"
				}
			]
			},
			{
			"featureType": "road.highway",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#616161"
				}
			]
			},
			{
			"featureType": "road.local",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			},
			{
			"featureType": "transit.line",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#e5e5e5"
				}
			]
			},
			{
			"featureType": "transit.station",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#eeeeee"
				}
			]
			},
			{
			"featureType": "water",
			"elementType": "geometry",
			"stylers": [
				{
				"color": "#c9c9c9"
				}
			]
			},
			{
			"featureType": "water",
			"elementType": "geometry.fill",
			"stylers": [
				{
				"color": "#4dbbc3"
				}
			]
			},
			{
			"featureType": "water",
			"elementType": "labels.text",
			"stylers": [
				{
				"visibility": "off"
				}
			]
			},
			{
			"featureType": "water",
			"elementType": "labels.text.fill",
			"stylers": [
				{
				"color": "#9e9e9e"
				}
			]
			}
		]

		var mapOptions = {
			center: {lat: 47.247913, lng: 8.674145},
			zoom: 14,
			disableDefaultUI: false,
			zoomControl: true,
			mapTypeControlOptions: {
					mapTypeIds: ['roadmap']
				},
			styles: style
		};
		var map = new google.maps.Map(document.getElementById('casawp-map'), mapOptions);

		var oms = new OverlappingMarkerSpiderfier(map, {
			markersWontMove: false,
			markersWontHide: false,
			basicFormatEvents: false
		});

		if ($('.casawp-property').length > 0) {
			$('.loading-overlay').removeAttr('style');
		}

		if (!$('.casawp-archive').hasClass('casawp-reference-archive')) {
			
			var $form = $('.casawp-filterform');
			var filteredParams = $form.serialize();
			//console.log(filteredParams);
			var url = $form.prop('action');
			url = url.replace(window.location.protocol + "//" + window.location.host, '');
			var url_last = window.location.href.split("?");
			//console.log(url_last);

			var filteredUrl = myAddParameterAndReturn(url + '?availabilities%5B%5D=active&' + url_last[1], 'ajax', '1');
			filteredUrl = myAddParameterAndReturn(filteredUrl, 'json', '1');

			requestMarkers(map, filteredUrl, oms);

			$('.casawp-filterform').on( "casawp-ajaxfilter:filter-submit", function(event, url, filteredUrl){
				requestMarkers(map, filteredUrl+"&ajax=1&posts_per_page=100&json=1", oms);
			});

		} else {
			requestMarkers(map, '/immobilien/?availabilities%5B%5D=reference&salestypes=&utilities=&categories=&locations=&rooms_from=&rooms_to=&features=&ajax=1&posts_per_page=100&json=1', oms);
		} 
	}

	if ($('#casawp-map').length) {
		google.maps.event.addDomListener(window, 'load', initializeMapBoxCasaWP);
	};


	if($('#menu-main-menu-fr').length){
		var searching = "recherche...";
		var noresults = "Aucun résultat trouvé";
		var shortinput = "Veuillez saisir au moins 2 caractères";
		var where = "Où ?";
	} else if($('#menu-main-menu-en').length){
		var searching = "search...";
		var noresults = "No result found";
		var shortinput = "Please enter at least 2 characters";
		var where = "Where?";
	} else if($('#menu-main-menu-it').length){
		var searching = "ricerca...";
		var noresults = "Nessun risultato trovato";
		var shortinput = "Si prega di inserire almeno 2 caratteri";
		var where = "Dove?";
	} else{
		var searching = "suchen...";
		var noresults = "Kein Resultat gefunden";
		var shortinput = "Bitte geben Sie mindestens 2 Zeichen ein";
		var where = "Wo?";
	}

	if ($('.wpforms-field-container .filter-field__select').length) {
		$('.wpforms-field-container .filter-field__select').append('<svg width="16px" height="14px" viewBox="0 0 18 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-475.000000, -1212.000000)"><rect fill="none" x="135" y="1131" width="1170" height="130"></rect><rect fill="none" x="205" y="1187" width="300" height="50"></rect><polyline fill="#727477" transform="translate(484.000000, 1215.500000) scale(1, -1) translate(-484.000000, -1215.500000) " points="493 1217.69701 484.00061 1212.00085 484.00061 1212 483.999913 1212.00034 483.99939 1212 483.99939 1212.00085 475 1217.69701 475 1219 483.999913 1213.30339 493 1219 493 1217.69701"></polyline></g></g></svg>');
	}	

	//single Properties back btn url
	if ($('body').hasClass('single-casawp_property')) {
		var filterParams = '?' + location.search.substring(0,1);
		var filterUrl = $('.casawp-single-prev').attr("href");
		if(location.search.substring(0,1)){
			$('.casawp-single-prev').attr("href", filterUrl + filterParams);
		} else{
			$('.casawp-single-prev').attr("href", filterUrl + "?availabilities%5B%5D=active&availabilities%5B%5D=reserved&salestypes%5B%5D=buy");
		}
	}

	$('.casawp-ajax-archive-list').on( "casawp-ajaxfilter:after-list-reload", function(event, url, filteredUrl){
		revealElements();
		fadeRevealElements();

		//archive Properties get url parameter
		var $form = $('.casawp-filterform');
		var filteredParams = $form.serialize();
		var filteredUrl = myAddParameterAndReturn('?' + filteredParams);
		filteredUrl = filteredUrl + '&posts_per_page=100';

		$(".wholeLink").each(function(){
			var _href = $(this).attr("href");
			var href = $(this).attr("href", _href + filteredUrl);
			var data = $(this).attr("data-filteroptions", filteredUrl);

		});

		var nodeList = document.querySelectorAll('.casawp-thumbnail-wrapper--flickity');

		for (var i = 0, t = nodeList.length; i < t; i++) {
			var flkty = Flickity.data(nodeList[i]);
			if (!flkty) {
				new Flickity(nodeList[i]);
			}
		}
	});


	rangeDropdownsToSlider();

	$('.casawp-filterform .casawp-radio-label').on("change", function(event){

		var fromElem = $('.casawp-filterform-pricecount-2').find("input[name=price_from]");
		var toElem = $('.casawp-filterform-pricecount-2').find("input[name=price_to]");

		fromElem.replaceWith('<input type="hidden" name="price_from"  value="" />');
		toElem.replaceWith('<input type="hidden" name="price_to"  value="" />');

		var fromElem = $('.casawp-filterform-roomscount-2').find("input[name=rooms_from]");
		var toElem = $('.casawp-filterform-roomscount-2').find("input[name=rooms_to]");

		fromElem.replaceWith('<input type="hidden" name="rooms_from"  value="" />');
		toElem.replaceWith('<input type="hidden" name="rooms_to"  value="" />');

		var location = $('.filter-field').find("select[name=locations]");
		location.replaceWith('<select class="form-control form-control-singleselect chosen-select" name="locations" value="" />');

		var category = $('.filter-field').find("select[name=categories\\[\\]]");
		category.replaceWith('<select class="form-control form-control-singleselect chosen-select" name="categories[]" value="" />');

	});

	
	$('.casawp-filterform').on( "casawp-filterform:after-filter-reload", function(event, url, filteredUrl){
		$('.casawp-radio-label').append('<i class="fal fa-check"></i>');
		//console.log(filteredUrl);
		rangeDropdownsToSlider();
		$('.casawp-filterform .casawp-radio-label').on("change", function(event){

			var fromElem = $('.casawp-filterform-pricecount-2').find("input[name=price_from]");
			var toElem = $('.casawp-filterform-pricecount-2').find("input[name=price_to]");

			fromElem.replaceWith('<input type="hidden" name="price_from"  value="" />');
			toElem.replaceWith('<input type="hidden" name="price_to"  value="" />');

			var fromElem = $('.casawp-filterform-roomscount-2').find("input[name=rooms_from]");
			var toElem = $('.casawp-filterform-roomscount-2').find("input[name=rooms_to]");

			fromElem.replaceWith('<input type="hidden" name="rooms_from"  value="" />');
			toElem.replaceWith('<input type="hidden" name="rooms_to"  value="" />');

			var location = $('.filter-field').find("select[name=locations]");
			location.replaceWith('<select class="form-control form-control-singleselect chosen-select" name="locations" value="" />');

			var category = $('.filter-field').find("select[name=categories\\[\\]]");
			category.replaceWith('<select class="form-control form-control-singleselect chosen-select" name="categories[]" value="" />');

		});
	});

	function rangeDropdownsToSlider(){
		if($('.casawp-filterform-pricecount-2')){

			$('.casawp-filterform-pricecount-2').each(function(idx, priceWrapperElem){
				const $priceWrapperElem = $(priceWrapperElem);
				const $fromElem = $priceWrapperElem.find("select[name=price_from]");
				const $toElem = $priceWrapperElem.find("select[name=price_to]");
				if ($fromElem.length && $toElem.length) {
					let fromVal = $fromElem.find("option:first-child").val();
					if (!fromVal) {
						//the first item ist often a mask
						fromVal = $fromElem.find("option:nth-child(2)").val();
					}
					//console.log(fromVal);
					const toVal = $toElem.find("option:last-child").val();
					if (fromVal && toVal) {
						$fromElem.replaceWith('<input type="number" name="price_from"  value="'+$fromElem.val()+'" />');
						$toElem.replaceWith('<input type="number" name="price_to"  value="'+$toElem.val()+'" />');

						const values = $fromElem.find('option').map(function() { return ($(this).val() ? parseInt($(this).val()) : 0); }).get();
						let range = {};
						values.forEach((value, idx) => {
							if (idx === 0) {
								range.min = value;
							} else if((idx+1) === values.length){
								range.max = value;
							} else {
								range[(idx*(100/values.length))+"%"] = value;
							}
						});
						console.log(range);

						let $rFromElem = $priceWrapperElem.find("input[name=price_from]");
						let $rToElem = $priceWrapperElem.find("input[name=price_to]");

						$priceWrapperElem.find('.casawp-filterform-duo-item label, .casawp-filterform-duo-item div, .casawp-filterform-duo-item input').hide();
						$priceWrapperElem.find('.casawp-filterform-duo-label').show();

						const $rangeSliderControl = $('<div class="form-control form-control-slider"><div class="noUi-placeholder" /></div>');
						$priceWrapperElem.append($rangeSliderControl);

						const sliderElem = $rangeSliderControl.find('.noUi-placeholder')[0];


						noUiSlider.create(sliderElem, {
							start: [
								(parseInt($fromElem.val()) ? parseInt($fromElem.val()) : 0),
								(parseInt($toElem.val()) ? parseInt($toElem.val()) : toVal)
							],
							connect: true,
							snap: true,
							range: range,

							format: {
								to: function ( value ) {
								return Math.round(value);
								},
								from: function ( value ) {
									return Math.round(value);
								}
							}

						});

						var priceSliderValues = [
							document.getElementById('price-slider-lower-value'),
							document.getElementById('price-slider-upper-value')
						];

						priceSliderValues[0].innerHTML = $fromElem.val();
						priceSliderValues[1].innerHTML = $toElem.val();


						sliderElem.noUiSlider.on('update', function( values, handle ) {
							priceSliderValues[handle].innerHTML = '' + values[handle].toLocaleString() + '.-';
						});

						

						sliderElem.noUiSlider.on('change', ( values, handle ) => {
							var value = values[handle];

							if ( handle === 0 ) {
								$rFromElem.val(Math.round(parseInt(value)));
							} else {
								if(value == range.max){
									$rToElem.val(null);
								} else{
									$rToElem.val(Math.round(parseInt(value)));
								}
								
							}

							$('.casawp-filterform').trigger('change');
						});
					}
				}
			})
		}

		if($('.casawp-filterform-roomscount-2')){
			$('.casawp-filterform-roomscount-2').each(function(idx, roomsWrapperElem){
				const $roomsWrapperElem = $(roomsWrapperElem);
				const $fromElem = $roomsWrapperElem.find("select[name=rooms_from]");
				const $toElem = $roomsWrapperElem.find("select[name=rooms_to]");

				if ($fromElem.length && $toElem.length) {
					let fromVal = $fromElem.find("option:first-child").val();
					if (!fromVal) {
						//the first item ist often a mask
						fromVal = $fromElem.find("option:nth-child(2)").val();
					}
					const toVal = $toElem.find("option:last-child").val();

					if (fromVal && toVal) {
						$fromElem.replaceWith('<input type="number" name="rooms_from" value="'+$fromElem.val()+'" />');
						$toElem.replaceWith('<input type="number" name="rooms_to" value="'+$toElem.val()+'" />');

						const values = $fromElem.find('option').map(function() { return ($(this).val() ? parseInt($(this).val()) : 0); }).get();
						let range = {};
						values.forEach((value, idx) => {
							if (idx === 0) {
								range.min = value;
							} else if((idx+1) === values.length){
								range.max = value;
							} else {
								range[(idx*(100/values.length))+"%"] = value;
							}
						});

						const $rFromElem = $roomsWrapperElem.find("input[name=rooms_from]");
						const $rToElem = $roomsWrapperElem.find("input[name=rooms_to]");

						$roomsWrapperElem.find('.casawp-filterform-duo-item label, .casawp-filterform-duo-item div, .casawp-filterform-duo-item input').hide();
						$roomsWrapperElem.find('.casawp-filterform-duo-label').show();

						const $rangeSliderControl = $('<div class="form-control form-control-slider"><div class="noUi-placeholder" /></div>');
						$roomsWrapperElem.append($rangeSliderControl);

						const sliderElem = $rangeSliderControl.find('.noUi-placeholder')[0];


						noUiSlider.create(sliderElem, {
							start: [
								(parseInt($fromElem.val()) ? parseInt($fromElem.val()) : 0),
								(parseInt($toElem.val()) ? parseInt($toElem.val()) : toVal)
							],
							connect: true,
							snap: true,
							range: range,
							format: {
								to: function ( value ) {
								return Math.round(value);
								},
								from: function ( value ) {
									return Math.round(value);
								}
							}

						});

						var roomsSliderValues = [
							document.getElementById('rooms-slider-lower-value'),
							document.getElementById('rooms-slider-upper-value')
						];

						roomsSliderValues[0].innerHTML = $fromElem.val();
						roomsSliderValues[1].innerHTML = $toElem.val();

						sliderElem.noUiSlider.on('update', function( values, handle ) {
							roomsSliderValues[handle].innerHTML = values[handle];
						});

						sliderElem.noUiSlider.on('change', ( values, handle ) => {
							var value = Math.round(parseInt(values[handle]));

							if ( handle === 0 ) {
								$rFromElem.attr('value', value);
							} else {
								$rToElem.attr('value', value);
							}

							$('.casawp-filterform').trigger('change');
						});
					}
				}
			})
		}
	}

	$('.int-value input').attr('name', 'intval');

	var initialInterestSettings = $.jStorage.get('interestResult');
	var $interestInputs = $('.wpforms-field-radio input, .wpforms-field-text input, .wpforms-field-number-slider input, .wpforms-field-select select, .wpforms-field-hidden input');

	//console.log(initialInterestSettings);

	// reset form values from json object
	if (initialInterestSettings && $('body').hasClass('page-template-page-template-interessenten')) {
		$(initialInterestSettings).each(function(index, item) {
			var name = item.name;
			var val = item.value;
			if (name == 'intval') {
				if ($('.interest-value').length) {
					$('.interest-value').text(val);
				}
				if ($('.form-int-value').length) {
					$('.form-int-value').val(val);
				}
			}
			if (name == 'wpforms[fields][10]') {
				if ($('.form-salestype-value').length) {
					$('.form-salestype-value').val(val);
				}
			}
			if (name == 'wpforms[fields][29]') {
				if ($('.form-locality-value').length) {
					$('.form-locality-value').val(val);
				}
			}
			if (name == 'wpforms[fields][17]') {
				if ($('.form-category-value').length) {
					$('.form-category-value').val(val);
				}
			}
			if (name == 'wpforms[fields][30]') {
				if ($('.form-rooms-value').length) {
					$('.form-rooms-value').val(val);
				}
			}
		});
	}

	$interestInputs.on('change', function(event) {
		var data = $interestInputs.serializeArray();
		$.jStorage.set('interestResult', data);	
	});

	$('.wpforms-form').on('submit', function(e){
		
		var data = $interestInputs.serializeArray();

		var inputArray = [];
		var storageArray = [];

		$.each( data, function( key, item ) {
			if (item.name != 'intval') {
				inputArray.push(item.value);
			}	
		});
		$.each( initialInterestSettings, function( key, item ) {
			if (item.name != 'intval') {
				storageArray.push(item.value);
			}
		});

		inputArray = inputArray.toString();
		storageArray = storageArray.toString();

		if (initialInterestSettings) {
			$(initialInterestSettings).each(function(index, item) {
				var name = item.name;
				var val = item.value;
				if (name == 'intval') {
					$('.int-value input').val(val);
					data = $interestInputs.serializeArray();
					$.jStorage.set('interestResult', data);
				}
			});
		}
		if ($.inArray('intval', $.map(initialInterestSettings, function(v) { return v.name; })) > -1) {
			if (inputArray !== storageArray) {
				var intval = Math.floor(Math.random() * 7) + 2;
				$('.int-value input').val(intval);
				data = $interestInputs.serializeArray();
				$.jStorage.set('interestResult', data);
			}
		} else {
			var intval = Math.floor(Math.random() * 7) + 2;
			$('.int-value input').val(intval);
			data = $interestInputs.serializeArray();
			$.jStorage.set('interestResult', data);
		}

	});

	if ($('.wpforms-field-checkbox').length) {
		$('.wpforms-field-checkbox li label').append('<span class="checkmark"></span>');
	}
	if ($('.wpforms-field-radio').length) {
		$('.wpforms-field-radio li label').append('<span class="checkmark"></span>');
	}

	if ($("html").attr("lang") == "es-ES") {
		$("#wpformshtml1").html("¿Qué lugares le interesan?");
		$("#wpformshtml2").html("\"No todos los listados son exhaustivos. Póngase en contacto con nosotros si está buscando una propiedad en una ubicación que no figura en la lista\"");
	} else if ($("html").attr("lang") == "en-US") {
		$("#wpformshtml1").html("What places are you interested in?");
		$("#wpformshtml2").html("\"Not all lists are exhaustive. Contact us if you are looking for a property in a location that is not on the list\"");
	} 

});




// WEBPACK FOOTER //
// ./src/js/main.js